/**
 * Add or remove an id from a "which rows are dirty" set, returning the SAME
 * set when nothing changes.
 *
 * The reference identity is the point. A React state updater that always
 * returns `new Set(prev)` re-renders the owner on every call even when the
 * membership is identical; with a child whose effect reports its dirty flag
 * on mount and cleanup, and a parent passing a fresh inline callback each
 * render, that is a render loop ("Maximum update depth exceeded" on Settings >
 * Email Accounts). Returning `prev` lets React bail out.
 */
export function withDirty(prev: Set<number>, id: number, dirty: boolean): Set<number> {
  if (dirty === prev.has(id)) return prev
  const next = new Set(prev)
  if (dirty) next.add(id)
  else next.delete(id)
  return next
}
